export default {
  'pages.dailyReport.title': 'Daily Report',
  'pages.dailyReport.subtitle': 'Manage and view daily work reports',
  'pages.dailyReport.create': 'Create Report',
  'pages.dailyReport.edit': 'Edit Report',
  'pages.dailyReport.batchDelete': 'Batch Delete',
  'pages.dailyReport.confirmDelete': 'Are you sure you want to delete this report?',
  'pages.dailyReport.confirmBatchDelete': 'Are you sure you want to delete {count} selected reports?',
  'pages.dailyReport.deleteSuccess': 'Report deleted successfully',
  'pages.dailyReport.batchDeleteSuccess': 'Reports deleted successfully',
  'pages.dailyReport.createSuccess': 'Report created successfully',
  'pages.dailyReport.updateSuccess': 'Report updated successfully',
  'pages.dailyReport.deleteFailed': 'Failed to delete report',
  'pages.dailyReport.batchDeleteFailed': 'Failed to delete reports',
  'pages.dailyReport.submitFailed': 'Failed to submit report',
  'pages.dailyReport.getListFailed': 'Failed to get report list',
  'pages.dailyReport.columns.reportDate': 'Report Date',
  'pages.dailyReport.columns.createdName': 'Submitted By',
  'pages.dailyReport.columns.todayWork': 'Today\'s Work',
  'pages.dailyReport.columns.tomorrowPlan': 'Tomorrow\'s Plan',
  'pages.dailyReport.columns.problem': 'Problems',
  'pages.dailyReport.columns.hours': 'Hours',
  'pages.dailyReport.columns.createTime': 'Create Time',
  'pages.dailyReport.columns.operations': 'Operations',
  'pages.dailyReport.actions.view': 'View',
  'pages.dailyReport.actions.edit': 'Edit',
  'pages.dailyReport.actions.delete': 'Delete',
  'pages.dailyReport.reportDateRequired': 'Please select report date',
  'pages.dailyReport.todayWorkRequired': 'Please enter today\'s work',
  'pages.dailyReport.todayWorkPlaceholder': 'Please enter today\'s work content',
  'pages.dailyReport.tomorrowPlanPlaceholder': 'Please enter tomorrow\'s plan',
  'pages.dailyReport.problemPlaceholder': 'Please enter problems encountered',
  'pages.dailyReport.hoursPlaceholder': 'Please enter hours worked',
  'pages.dailyReport.detail.title': 'Report Details',
  'pages.dailyReport.detail.basicInfo': 'Basic Information',
  'pages.dailyReport.detail.timeInfo': 'Time Information',
  'pages.dailyReport.detail.todayWork': 'Today\'s Work',
  'pages.dailyReport.detail.tomorrowPlan': 'Tomorrow\'s Plan',
  'pages.dailyReport.detail.problem': 'Problems',
};
